<template>
    <div class="container">
        <h2 class="mb-5 text-center">{{page.title}}</h2>
        <div v-html="page.content"></div>
        <hr>
        <a
            href="https://datatool.workitaround.com/uploads/howto.pdf"
            target="_blank"
        >Go to how-to.pdf documentation.</a>
    </div>
</template>

<script>
    export default {
        data() {
            return {
                introPageId: 4
            };
        },

        computed: {
            page() {
                return this.$store.state.app.staticPage;
            }
        },

        mounted() {
            this.$store.dispatch('app/getStaticPage', this.introPageId);
        }
    };
</script>
